import api from 'service/api'

const dponetAPI = api.create('dponet', false)

const get = async ({ regulationId = '', ...params }) => {
  return dponetAPI.get(
    `/backoffice/regulations/${regulationId}/regulation_versions`,
    { params },
  )
}

const create = async ({ regulationId = '', ...data }) => {
  return dponetAPI.post(
    `/backoffice/regulations/${regulationId}/regulation_versions`,
    { regulationVersion: data },
  )
}

const changeStatus = async ({ id = '', regulationId = '', ...data }) => {
  return dponetAPI.patch(
    `/backoffice/regulations/${regulationId}/regulation_versions/${id}/change_status`,
    {
      regulationVersion: data,
    },
  )
}

const regulationVersions = { create, get, changeStatus }

export default regulationVersions
